import { AppBar, Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import {
  Logo2,
  MOD,
  MobileMenu as MobileMenuIcon,
  OutlinedBluePhone,
} from 'Images';
import { UserAccordion } from './UserAccordion';
import { useNavigate } from 'react-router-dom';
import { RoutesConfig } from 'Routes';
import { useState } from 'react';
import { MobileMenu } from './MobileMenu';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

export const Header2 = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Header);
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  return (
    <Stack height={isDesktop ? '80px' : '72px'}>
      <AppBar
        sx={{
          height: isDesktop ? '80px' : '72px',
          boxShadow: 'none',
          zIndex: 1400,
        }}
      >
        <Stack
          direction={'row'}
          justifyContent={isDesktop ? 'space-between' : 'center'}
          gap={isDesktop ? '0' : '50px'}
          padding={isDesktop ? '16px 40px' : '20px 14px 20px 0'}
          height={'100%'}
          bgcolor={'text.secondary'}
        >
          <Stack
            direction={'row'}
            alignSelf={'center'}
            position={isDesktop ? 'static' : 'absolute'}
            width={'auto'}
            gap={'16px'}
            left={0}
            top={'50%'}
            sx={{
              transform: isDesktop ? undefined : 'translateY(-50%)',
            }}
          >
            {isDesktop ? (
              <Stack direction={'row'} gap={'31px'}>
                <Stack
                  width={'auto'}
                  alignItems={'center'}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    window.location.href =
                      process.env.REACT_APP_MARKETING_SITE_URL || '';
                  }}
                  onKeyDown={onEnterOrEscapeKeyDown}
                  tabIndex={0}
                  component='a'
                >
                  <Avatar
                    src={Logo2}
                    alt={''}
                    sx={{ height: '38px', width: '33px' }}
                  />
                  <Typography variant={'body6'} component={'h2'}>
                    {dictionary.shikum}
                  </Typography>
                </Stack>
                <Stack
                  width={'auto'}
                  alignItems={'center'}
                  sx={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open(process.env.REACT_APP_DEFAULT_MOD_BASE_URL)
                  }
                  onKeyDown={onEnterOrEscapeKeyDown}
                  tabIndex={0}
                  component='a'
                >
                  <Avatar
                    alt={''}
                    src={MOD}
                    sx={{ height: '37px', width: '34px' }}
                  />
                  <Typography variant={'body6'} component={'h2'}>
                    {dictionary.ministryOfDefense}
                  </Typography>
                </Stack>
              </Stack>
            ) : (
              <>
                <Button
                  sx={{ padding: '0', minWidth: '0' }}
                  tabIndex={0}
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                  <Avatar
                    alt={''}
                    src={MobileMenuIcon}
                    sx={{ width: '52px', height: '48px' }}
                  />
                </Button>
                {isMobileMenuOpen && (
                  <MobileMenu
                    isMobileMenuOpen={isMobileMenuOpen}
                    setIsMobileMenuOpen={setIsMobileMenuOpen}
                  />
                )}
                <Stack width={'auto'} alignItems={'center'}>
                  <Avatar
                    src={Logo2}
                    alt={''}
                    sx={{ height: '27px', width: '30px' }}
                  />
                  <Typography fontSize={'14px'} fontWeight={500} tabIndex={0}>
                    {dictionary.logoMobile}
                  </Typography>
                </Stack>
              </>
            )}
          </Stack>
          <Stack
            direction={'row'}
            alignSelf={isDesktop ? 'center' : 'initial'}
            margin={isDesktop ? '0' : 'auto 0 auto auto'}
            width={'auto'}
            gap={isDesktop ? '12px' : '16px'}
            height={isDesktop ? 'auto' : '100%'}
          >
            <Button
              sx={{
                padding: '0',
                minWidth: '0',
                bgcolor: '#fff',
                gap: '5px',
                borderRadius: '8px',
                width: isDesktop ? '129px' : '110px',
                '&:hover': {
                  bgcolor: '#fff',
                },
              }}
              onClick={() => navigate(RoutesConfig.PERSONAL_TEAM.PATH)}
            >
              <Avatar
                src={OutlinedBluePhone}
                sx={{
                  width: isDesktop ? '28px' : '20px',
                  height: isDesktop ? '28px' : '20px',
                }}
              />
              <Typography variant={'body5'}>{dictionary.myTeam}</Typography>
            </Button>
            <UserAccordion />
          </Stack>
        </Stack>
      </AppBar>
    </Stack>
  );
};
